/**
 * V2 share menu (2026-07-27, user ask): one "Share ▾" control where a
 * row of outlined buttons used to sit — Share photos / Embed map /
 * Share link collapsed into a pulldown, so every share surface carries
 * one button of chrome instead of three.
 *
 * The existing buttons (ui/share.js, ui/embed.js, ui/share-photos.js)
 * become the menu's rows UNCHANGED — same markup, same data attributes —
 * so every page's delegated click handlers keep working and each row's
 * label feedback ("Link copied ✓", "Making your card…") still shows in
 * place. That is also why the menu does NOT close when a row is tapped:
 * the row is where its own feedback appears. It closes on an outside
 * tap or Escape, via one module-level listener.
 *
 * With a single item there is nothing to economize: it renders as-is,
 * which lets callers wrap unconditionally (a private list's share row
 * has no Embed, and stays a plain button).
 *
 * Native <details>/<summary> does the toggling — keyboard for free, and
 * no coupling to any view's render cycle.
 */
import { icon } from './icons.js';

let closerInstalled = false;

function closeOpenMenus(except = null) {
  document.querySelectorAll('details.v2-share-menu[open]').forEach((menu) => {
    if (menu !== except) menu.open = false;
  });
}

function installCloser() {
  if (closerInstalled) return;
  closerInstalled = true;
  document.addEventListener('click', (event) => {
    const inside = event.target.closest?.('details.v2-share-menu');
    closeOpenMenus(inside);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeOpenMenus();
  });
}

/**
 * Wrap share actions in the pulldown.
 * @param {...string} items - Rendered button HTML ('' entries are skipped)
 * @returns {string}
 */
export function shareMenu(...items) {
  const rows = items.filter(Boolean);
  if (!rows.length) return '';
  if (rows.length === 1) return rows[0];
  installCloser();
  return `
    <details class="v2-share-menu">
      <summary class="v2-share-menu-btn" aria-label="Share options">
        ${icon('share', 16)}<span>Share</span><span class="share-menu-caret" aria-hidden="true">▾</span>
      </summary>
      <div class="v2-share-menu-pop">${rows.join('')}</div>
    </details>`;
}
